import { getInfo, login, loginByWeiXin, logout } from '@/api/login';
import { getToken, removeToken, setToken } from '@/utils/auth';
import cache from '@/plugins/cache';

const user = {
  state: {
    token: getToken(),
    info: null,
    roles: null,
    permissions: null
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    }, SET_INFO: (state, info) => {
      state.info = info;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    }, SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    }
  },

  actions: {
    // 微信登录
    LoginByWeiXin({ commit }, openID) {
      return new Promise((resolve, reject) => {
        loginByWeiXin({ openID: openID }).then(res => {
          if (!res.token) {
            reject('未获取到token信息');
          } else {
            setToken(res.token);
            commit('SET_TOKEN', res.token);
            resolve(res);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password;
      const code = userInfo.code;
      const uuid = userInfo.uuid;
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          setToken(res.token);
          commit('SET_TOKEN', res.token);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          cache.local.setJSON('userInfo', res.user);
          commit('SET_INFO', res.user);
          if (res.roles && res.roles.length > 0) {
            commit('SET_ROLES', res.roles);
            commit('SET_PERMISSIONS', res.permissions);
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT']);
          }
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          commit('SET_PERMISSIONS', []);
          removeToken();
          // storage.clean()
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default user;
